import { render, staticRenderFns } from "./Action_feedback.vue?vue&type=template&id=408cff5d&scoped=true&"
import script from "./Action_feedback.vue?vue&type=script&lang=js&"
export * from "./Action_feedback.vue?vue&type=script&lang=js&"
import style0 from "./Action_feedback.vue?vue&type=style&index=0&id=408cff5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408cff5d",
  null
  
)

export default component.exports